<template>
  <el-dialog
    title="自定义功能"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    :before-close="close"
  >
    <div class="div-function-root">
      <div class="box">
        <div class="title">
          <div class="required" style="left: 80px">*</div>
          paId:
        </div>
        <div class="content">
          <el-input type="number" v-model="params.paId" placeholder="请输入paId"></el-input>
        </div>
      </div>
      <div class="box">
        <div class="title">
          <div class="required" style="left: 50px">*</div>
          功能名称:
        </div>
        <div class="content">
          <el-input v-model="params.funcName" placeholder="功能点名称"></el-input>
        </div>
      </div>
      <div class="box">
        <div class="title">
          <div class="required" style="left: 68px">*</div>
          标识符:
        </div>
        <div class="content">
          <el-input v-model="params.fieldName" placeholder="以字母开头"></el-input>
        </div>
      </div>
      <div class="box">
        <div class="title">
          <div class="required" style="left: 53px">*</div>
          数据类型:
        </div>
        <div class="content">
          <el-radio
            @input="radioBtn"
            v-model="params.dataType"
            v-for="(item, index) in dataType"
            style="margin-bottom: 10px"
            :index="index"
            :label="item.id"
            >{{ item.label }}</el-radio
          >
        </div>
      </div>
      <!-- -------------------------------可变动数据类型 -->
      <div v-show="params.dataType == 2">
        <div class="box">
          <div class="title">
            <div class="required" style="left: 53px">*</div>
            数值范围:
          </div>
          <div class="content">
            <el-input-number :min="-999" size="small"  :precision="0" v-model="addition.min"></el-input-number>
            -
            <el-input-number :min="-999" size="small" v-model="addition.max"></el-input-number>
          </div>
        </div>

        <div class="box">
          <div class="title">
            <div class="required" style="left: 80px">*</div>
            间距:
          </div>
          <div class="content">
            <el-input-number :min="0" size="small" v-model="addition.step"></el-input-number>
          </div>
        </div>

        <div class="box">
          <div class="title">
            <div class="required" style="left: 80px">*</div>
            倍数:
          </div>
          <div class="content">
            <el-input-number :min="0" size="small" v-model="addition.ratio"></el-input-number>
          </div>
        </div>

        <div class="box">
          <div class="title">
            <div class="required" style="left: 80px">*</div>
            单位:
          </div>
          <div class="content">
           <el-input v-model="addition.unit" placeholder="请输入单位"></el-input>
          </div>
        </div>
      </div>
      <div v-show="params.dataType == 3">
        <div class="box">
        <div class="title">
          <div class="required" style="left: 67px">*</div>
          枚举值:
        </div>
        <div class="content">
          <div class="enum">
            <div class="enumList" v-for="(item,index) in enumList" :key="index">
              <input type="text" class="inputPage" :placeholder="item" @input="inputPageFun(item,index,$event)">
            </div>
            <div class="addenum" @click="addenum">
              <i class="el-icon-plus" style="margin-right: 3px;"></i>枚举值
            </div>
          </div>
        </div>
      </div>
      </div>
      <div v-show="params.dataType == 4">
        <div class="box">
        <div class="title">
          <div class="required" style="left: 67px">*</div>
          故障值:
        </div>
        <div class="content">
          <div class="enum">
            <div class="enumList" v-for="(item,index) in enumList" :key="index">
              <input type="text" class="inputPage" :placeholder="item" @input="inputPageFun(item,index,$event)">
            </div>
            <div class="addenum" @click="addenum">
              <i class="el-icon-plus" style="margin-right: 3px;"></i>故障值
            </div>
          </div>
        </div>
      </div>
      </div>
      <!-- ---------------------------------------------------------- -->
      <div class="box">
        <div class="title">
          <div class="required" style="left: 25px">*</div>
          数据传输类型:
        </div>
        <div class="content">
          <el-radio
            v-model="params.transferMode"
            :disabled="item.disabled(params.dataType)"
            v-for="(item, index) in transferModeList"
            style="margin-bottom: 10px"
            :index="index"
            :label="item.id"
            >{{ item.label }}</el-radio
          >
        </div>
      </div>
      <div class="box">
        <div class="title">备注:</div>
        <div class="content">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入内容"
            v-model="params.remark"
          >
          </el-input>
        </div>
      </div>
      <!-- <div class="box">
        <div class="title">特殊配置:</div>
        <div class="content">
          
        </div>
      </div> -->
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { iotApi } from '../../../../utils/config';
import { postFun } from '../../../../utils/httpFun';

export default {
  data() {
    return {
      operate:'add',
      enumList:[],
      addition: {
        min:0,
        max:0,
        step:0,
        ratio:0,
        unit:0
      },
      dialogVisible: false,
      params: {
        pId: null,
        paId:null,
        standard: 1,
        funcName: null,
        fieldName: null,
        transferMode:  "r",
        dataType: 1,
        remark: null,
      },
      dataType: [
        {
          id: 1,
          label: "布尔(Bool)",
        },
        {
          id: 2,
          label: "数字(Vlaue)",
        },
        {
          id: 3,
          label: "枚举(Enum)",
        },
        {
          id: 4,
          label: "故障(Fault)",
        },
        {
          id: 5,
          label: "字符(String)",
        },
        {
          id: 6,
          label: "透传(Raw)",
        },
      ],
      transferModeList: [
        {
          id: "r",
          label: "上报",
          disabled: (ev) => {
            // if(ev == 4)return true;
            return false;
          },
        },
        {
          id: "w",
          label: "下发",
          disabled: (ev) => {
            if(ev == 4)return true;
            return false;
          },
        },
        {
          id: "rw",
          label: "上报与下发",
          disabled: (ev) => {
            if(ev == 4)return true;
            return false;
          },
        },
      ],
      serachCallback:()=>{},
      edit:{}
    };
  },
  methods: {
    radioBtn(ev){
      console.log("编号",ev);

      if(this.operate == 'edit' && this.edit.dataType == ev){
        if(this.edit.dataType == 2){
          this.addition = !!!this.edit.attachAttr?{}:JSON.parse(this.edit.attachAttr); 
        }else if(this.edit.dataType == 3 || this.edit.dataType == 4){
          let arr = JSON.parse(this.edit.attachAttr) || [];
          arr.forEach((item)=>{
            this.enumList.push(item);
          })
          // this.$set(this,'enumList',JSON.parse(this.edit.attachAttr) || [])
          console.log('========',this.enumList)
        }
      }else{
        this.addition = {};
        this.enumList = [];
      }
    },
    open(operate,item,serachCallback) {
      console.log("=======测试",item);
      this.dialogVisible = true;
      this.operate = operate;
      this.serachCallback = serachCallback;
      this.params.pId = this.$parent.getPid();
      this.edit = item;

      if(operate == 'edit'){
        this.params.paId = this.edit.paId;
        this.params.id = this.edit.id;
        this.params.dataType = this.edit.dataType;
        this.params.fieldName = this.edit.fieldName;
        this.params.funcName = this.edit.funcName;
        this.params.remark = this.edit.remark;
        this.params.pId = this.edit.pId;
        this.params.standard = this.edit.standard;
        this.params.transferMode = this.edit.transferMode;
        if(this.params.dataType == 2){
          this.addition = !!!this.edit.attachAttr?{}:JSON.parse(this.edit.attachAttr); 
          console.log('addition',this.addition)
        }else if(this.params.dataType == 3 || this.params.dataType == 4){
          let arr = JSON.parse(this.edit.attachAttr) || [];
          arr.forEach((item)=>{
            this.enumList.push(item);
          })
          // this.$set(this,'enumList',JSON.parse(this.edit.attachAttr) || [])
          console.log('========',this.enumList)
        }
      }
    },
    close() {
      this.params.id = null;
      this.params = {
        pId: null,
        paId:null,
        standard: 1,
        funcName: null,
        fieldName: null,
        transferMode:  "r",
        dataType: 1,
        remark: null
      }
      this.addition = {
        min:0,
        max:0,
        stop:0,
        ratio:0,
        unit:0
      }
      this.enumList = [];
      console.log('========关闭==',this.dialogVisible)
      this.dialogVisible = false;
    },
    inputPageFun(value,index,e){
      this.enumList[index] = e.target.value;
    },
    addenum(){
      this.enumList.push('请输入')
    },
    async submit(){
      console.log('===============',this.enumList,this.$parent.getPid());
      let param = {
        ...this.params
      }

      let isCheck = await this.check();
      if(!isCheck)return;
      // debugger;
      if(this.params.dataType == 2){
        param.attachAttr = JSON.stringify(this.addition);
      }else if(this.params.dataType == 3 || this.params.dataType == 4){
        param.attachAttr = JSON.stringify(this.enumList);
      }

      console.log('========',param);
      if(this.operate == 'add'){
        postFun(iotApi.CREATEPRODUCTATTR,param,res=>{
          if(res.data){
            this.$message.success("创建成功");
            this.serachCallback('add');
          }else{
            this.$message.warning("创建失败");
          }
          this.close();
        })
      }else if(this.operate == 'edit'){
        postFun(iotApi.UPDATEBYPRIMARYKEY,param,res=>{
          if(res.data){
            this.$message.success("编辑成功");
            this.serachCallback('edit');
          }else{
            this.$message.warning("编辑失败");
          }
          this.close();
        })
      }
    },
    check(){
      let rule = /^[A-Za-z][\w\W]*$/;
      let isCheck = true;

      if(!!!this.params.paId){
        this.$message.warning('请输入paId');
        isCheck = false;
      }else if(this.params.paId >= 100 ||  this.params.paId < 0){
        this.$message.warning('paid必须小于100并且大于0');
        isCheck = false;
      }else if(!!!this.params.funcName){
        this.$message.warning('请输入功能名称');
        isCheck = false;
      }else if(!!!this.params.fieldName){
        this.$message.warning('请输入标识符');
        isCheck = false;
      }else if(!rule.test(this.params.fieldName)){
        this.$message.warning('标识符只能以字母开头');
        isCheck = false;
      }else if(!!!this.params.dataType){
        this.$message.warning('请选择数据类型');
        isCheck = false;
      }else if(!!!this.params.transferMode){
        this.$message.warning('请选择数据传输类型');
        isCheck = false;
      }else if(this.params.dataType == 2){
        // if(!!!this.addition.min){
        //   this.$message.warning('请输入最小值');
        //   isCheck = false;
        // }
        // else if(!!!this.addition.max){
        //   this.$message.warning('请输入最大值');
        //   isCheck = false;
        // }
        if(this.addition.min == null){
          this.$message.warning('请输入最小值');
          isCheck = false;
        }
        else if(this.addition.max == null){
          this.$message.warning('请输入最大值');
          isCheck = false;
        }
        else if(this.addition.min >= this.addenum.max){
          this.$message.warning('最小值不能大于或等于最大值');
          isCheck = false;
        }
        else if(!!!this.addition.step){
          this.$message.warning('请输入间距');
          isCheck = false;
        }
        else if(!!!this.addition.ratio){
          this.$message.warning('请输入倍数');
          isCheck = false;
        }
        else if(!!!this.addition.unit){
          this.$message.warning('请输入单位');
          isCheck = false;
        }
      }else if(this.params.dataType == 3 || this.params.dataType == 4){
        if(this.enumList.length == 0){
          this.$message.warning(`请增加${this.params.dataType == 3?'枚举值':'故障值'}`);
          isCheck = false;
        }
      }else{
        isCheck = true;
      }

      return new Promise((resolve,reject)=>{
        resolve(isCheck);
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.inputPage{
  width: 80px;
  border-color: transparent;
  &:focus{
    border-color: transparent;
    outline: none;
  }
  &:hover{
    border-color: transparent;
  }
}
.enum{
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  .enumList{
    font-size: 13px;
    width: 100px;
    height: 35px;
    margin-bottom: 10px;
    border: 1px solid rgba(0,0,0,0.2);
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
  }
  .addenum{
    cursor: pointer;
    font-size: 13px;
    width: 100px;
    height: 35px;
    color: #989898;
    border: 1px dotted rgba(0,0,0,0.2);
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.div-function-root {
  width: 100%;
  height: 100%;
}
.box {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  position: relative;
}
.required {
  color: red;
  position: absolute;
  left: 0;
  // top: -10px;
}
.title {
  position: relative;
  width: 120px;
  text-align: right;
  margin-right: 10px;
}
.content {
  width: 385px;
  margin-bottom: 20px;
}
::v-deep .el-dialog__header {
  width: 92%;
  height: 23px;
  // background: #F8F9FA;
  box-shadow: 0px 1px 0px 0px rgb(237 238 240);
  border-radius: 12px 12px 0 0;
  margin-bottom: 20px;
}
::v-deep .el-dialog {
  border-radius: 12px;
}
</style>